import React from 'react';
import './Misc.css';

/* ──────────────────────────────────────────────
 * Badge
 * ──────────────────────────────────────────────*/
export const Badge = ({
  children,
  variant = 'neutral',
  className = '',
  ...rest
}) => (
  <span className={`tdk-badge tdk-badge--${variant} ${className}`} {...rest}>
    {children}
  </span>
);

/* ──────────────────────────────────────────────
 * Stat — icon + label + value tile
 *
 *   <Stat
 *     icon={<Activity />}
 *     label="Trainings"
 *     value={42}
 *     hint="last 30 days"
 *     tone="primary"
 *   />
 * ──────────────────────────────────────────────*/
export const Stat = ({
  icon,
  label,
  value,
  hint,
  tone = 'primary',
  className = '',
  ...rest
}) => (
  <div className={`tdk-stat ${className}`} data-testid={rest['data-testid']} {...rest}>
    {icon && (
      <span className={`tdk-stat__icon tdk-stat__icon--${tone}`} aria-hidden="true">
        {icon}
      </span>
    )}
    <div>
      {label && <p className="tdk-stat__label">{label}</p>}
      <p className="tdk-stat__value">{value}</p>
      {hint && <p className="tdk-stat__hint">{hint}</p>}
    </div>
  </div>
);

/* ──────────────────────────────────────────────
 * PageHeader — h1 + subtitle + right-aligned actions
 * ──────────────────────────────────────────────*/
export const PageHeader = ({
  title,
  subtitle,
  actions,
  className = '',
  ...rest
}) => (
  <header className={`tdk-page-header ${className}`} {...rest}>
    <div>
      <h1 className="tdk-page-header__title">{title}</h1>
      {subtitle && <p className="tdk-page-header__subtitle">{subtitle}</p>}
    </div>
    {actions && <div className="tdk-page-header__actions">{actions}</div>}
  </header>
);

/* ──────────────────────────────────────────────
 * Stack — primitive vertical (or horizontal) layout
 *
 *   <Stack gap={4}>…</Stack>
 *   <Stack direction="row" gap={2}>…</Stack>
 * ──────────────────────────────────────────────*/
export const Stack = ({
  children,
  gap = 4,
  direction = 'column',
  className = '',
  as: Tag = 'div',
  ...rest
}) => (
  <Tag
    className={`tdk-stack ${className}`}
    data-gap={String(gap)}
    data-direction={direction}
    {...rest}
  >
    {children}
  </Tag>
);

/* ──────────────────────────────────────────────
 * Section — vertical breathing room helper
 * ──────────────────────────────────────────────*/
export const Section = ({ children, className = '', ...rest }) => (
  <section className={`tdk-section ${className}`} {...rest}>{children}</section>
);
